export default {
  bailiff_id: null,
  guarantor_id: null,
  send_date: null,
  release_date: null,
  payments_sum: 0,
  contributions_sum: 0,
  consignment_number: null,
  schedule_id: null,
  client_id: null,
  bailiff: {},
  contributions: [],
  payments: [],
  applications: [],
  new_applications: [],
  expenses: [],
  receipt_date: null
}
